import { attr, FASTElement, html } from "@microsoft/fast-element";
import { designTokens } from "../../design-tokens";
import { NatGenDesignSystem } from "../../natgen-design-system";

/**
 * @element natgen-token-value
 */
export class NatGenTokenValue extends FASTElement {
    @attr
    public name: string;
}

export const natGenTokenValueDefinition = NatGenTokenValue.compose({
    name: `${NatGenDesignSystem.prefix}-token-value`,
    template: html<NatGenTokenValue>`
        <template>
            ${x => designTokens[x.name]?.getValueFor(x)}
        </template>
    `
});
